import { useState } from 'react';
import type { DateRange } from '../../../../api/marketing';

interface DateRangeSelectorProps {
  value: DateRange;
  onChange: (range: DateRange) => void;
}

const PRESETS: { label: string; days: number }[] = [
  { label: '7d', days: 7 },
  { label: '30d', days: 30 },
  { label: '90d', days: 90 },
];

function daysAgo(days: number): DateRange {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - days);
  return {
    startDate: start.toISOString().split('T')[0],
    endDate: end.toISOString().split('T')[0],
  };
}

export default function DateRangeSelector({ value, onChange }: DateRangeSelectorProps) {
  const [isCustom, setIsCustom] = useState(false);

  const activePreset = PRESETS.find((p) => {
    const preset = daysAgo(p.days);
    return preset.startDate === value.startDate && preset.endDate === value.endDate;
  });

  return (
    <div className="flex items-center gap-2">
      {PRESETS.map((preset) => (
        <button
          key={preset.label}
          onClick={() => {
            setIsCustom(false);
            onChange(daysAgo(preset.days));
          }}
          className={`px-3 py-1.5 text-xs font-medium rounded-md transition ${
            !isCustom && activePreset?.label === preset.label
              ? 'bg-moss-600 text-white'
              : 'bg-stone-100 dark:bg-[#242d28] text-stone-600 dark:text-stone-400 hover:bg-stone-200 dark:hover:bg-[#2a352e]'
          }`}
        >
          {preset.label}
        </button>
      ))}
      <button
        onClick={() => setIsCustom(true)}
        className={`px-3 py-1.5 text-xs font-medium rounded-md transition ${
          isCustom
            ? 'bg-moss-600 text-white'
            : 'bg-stone-100 dark:bg-[#242d28] text-stone-600 dark:text-stone-400 hover:bg-stone-200 dark:hover:bg-[#2a352e]'
        }`}
      >
        Custom
      </button>
      {isCustom && (
        <div className="flex items-center gap-1.5 ml-1">
          <input
            type="date"
            value={value.startDate}
            onChange={(e) => onChange({ ...value, startDate: e.target.value })}
            className="px-2 py-1 text-xs border border-stone-300 dark:border-stone-600 rounded-md bg-white dark:bg-[#1a1f1c] text-bark-900 dark:text-stone-200"
          />
          <span className="text-xs text-stone-400">to</span>
          <input
            type="date"
            value={value.endDate}
            onChange={(e) => onChange({ ...value, endDate: e.target.value })}
            className="px-2 py-1 text-xs border border-stone-300 dark:border-stone-600 rounded-md bg-white dark:bg-[#1a1f1c] text-bark-900 dark:text-stone-200"
          />
        </div>
      )}
    </div>
  );
}

export { daysAgo };
